import BUApi from './_buApi';
import httpClient from '@/apis/base/httpclient';

class bUPlanAdjustmentAPI extends BUApi {
  constructor() {
    super();
  }
  controllerName = 'BUPlanAdjustments';

  /**
   * Lấy dữ liệu details
   * @param {*} payload
   * @returns
   * bnanh 18.07.2022
   */
  getBUPlanAdjustmentDetails(payload) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/BUPlanAdjustmentDetails',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu thêm mới theo ngày hạch toán
   * @param {*} payload
   * @returns
   * bnanh 18.07.2022
   */
  getBUPlanAdjustment(payload) {
    let request = {
      url: this.getAPIUrl() + '/BUPlanAdjustment',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}
export default new bUPlanAdjustmentAPI();
